import React from "react";
import { Box, Skeleton } from "@mui/material";

const AudioCollectionLoading = () => {
  const skeletonStyles = {
    backgroundColor: "white",
    color: "white",
  };

  // Create array for multiple skeleton items
  const skeletonItems = Array.from({ length: 4 }, (_, index) => index);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="space-y-4 pt-10">
        {skeletonItems.map((_, index) => (
          <div key={index} className="relative">
            <div className="p-6">
              {/* Book Cover Skeleton with absolute positioning */}
              <div className="absolute left-10 -mt-6 z-1">
                <Skeleton
                  variant="rectangular"
                  className="rounded-lg shadow-lg"
                  width={64}
                  height={80}
                  sx={{ ...skeletonStyles }}
                />
              </div>

              {/* First Row: Gray background section */}
              <div className="flex bg-gray-300 rounded-xl px-4 py-4 items-center mb-4">
                {/* Space for the overlapping image */}
                <div className="flex-shrink-0 mr-6 w-16">
                  {/* Empty space where image overlaps */}
                </div>

                {/* Title and Author Skeletons */}
                <div className="flex-1 min-w-0">
                  <Skeleton
                    variant="text"
                    width="70%"
                    height={20}
                    sx={{ 
                      ...skeletonStyles, 
                      marginBottom: "4px",
                      backgroundColor: "#d1d5db" // Slightly darker for contrast on gray background
                    }}
                  />
                  <Skeleton
                    variant="text"
                    width="50%"
                    height={18}
                    sx={{ 
                      ...skeletonStyles,
                      backgroundColor: "#d1d5db"
                    }}
                  />
                </div>

                {/* Chevron Skeleton */}
                <Skeleton
                  variant="circular"
                  width={24}
                  height={24}
                  sx={{ 
                    ...skeletonStyles,
                    backgroundColor: "#d1d5db"
                  }}
                />
              </div>

              {/* Second Row: Summary Skeleton */}
              <div className="mt-1">
                <Skeleton
                  variant="text"
                  width="95%"
                  height={16}
                  sx={{ 
                    ...skeletonStyles, 
                    marginBottom: "4px",
                    backgroundColor: "#e5e7eb"
                  }}
                />
                <Skeleton
                  variant="text"
                  width="85%"
                  height={16}
                  sx={{ 
                    ...skeletonStyles, 
                    marginBottom: "4px",
                    backgroundColor: "#e5e7eb"
                  }}
                />
                <Skeleton
                  variant="text"
                  width="60%"
                  height={16}
                  sx={{ 
                    ...skeletonStyles,
                    backgroundColor: "#e5e7eb"
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Spacing */}
      <div className="h-6"></div>
    </div>
  );
};

export default AudioCollectionLoading;